import ItineraryTimeline from "../PackageInfo/ItineraryTimeline";
import Header from "../PackageInfo/Header";
import ModalTriggerList from "../CommonUI/ModalTriggerList";
import JoinEventAction from "../CommonUI/JoinEventAction";
import TrekBasicInfo from "../CommonUI/TrekBasicInfo";
import PackageInclusions from "../CommonUI/PackageInclusions";
import ImageCardsWithVerticalView from "../PackageInfo/ImageCardsWithverticalView";

import dev1 from "../../Images/Devkund/dev1.jpg";
import dev2 from "../../Images/Devkund/dev2.JPG";
import dev3 from "../../Images/Devkund/dev3.jpg";
import dev4 from "../../Images/Devkund/dev4.jpg";
import dev5 from "../../Images/Devkund/dev5.jpg";

const data = [
  {
    day: "Day 1",
    subheading: "Devkund Waterfall Trek",
    schedule: [
      { time: "05:00 AM", activity: "Pick-up at Hadapsar." },
      { time: "05:20 AM", activity: "Pick-up at Swargate." },
      { time: "05:40 AM", activity: "Pick-up at Vanaj Metro Station." },
      { time: "05:55 AM", activity: "Pick-up at Wakad Bridge." },
      { time: "06:10 AM", activity: "Pick-up at Hinjwadi." },
      {
        time: "08:30 AM",
        activity: "Reach Bhira Base Village and complete trek briefing.",
      },
      {
        time: "09:00 AM",
        activity: "Breakfast at Base Village.",
      },
      {
        time: "10:00 AM",
        activity: "Begin the scenic trek towards Devkund Waterfall.",
      },
      {
        time: "12:30 PM",
        activity:
          "Reach Devkund Waterfall viewpoint and enjoy the magnificent scenery.",
      },
      {
        time: "01:00 PM",
        activity:
          "Relax, click photographs, and enjoy the beauty of the waterfall.",
      },
      {
        time: "01:30 PM",
        activity: "Begin the return trek towards the base village.",
      },
      {
        time: "03:30 PM",
        activity: "Reach base village and enjoy Veg & Non-Veg Lunch.",
      },
      {
        time: "04:30 PM",
        activity: "Start the return journey to Pune.",
      },
      {
        time: "09:00 PM",
        activity: "Approx. arrival back in Pune.",
      },
    ],
    meals: ["Breakfast", "Lunch", "Tea"],
    notes: [
      "Forest Department permits for Devkund are limited and subject to availability. Early booking is highly recommended.",
    ],
    inclusions: [
      "🚌 Pune to Pune Travel by Non-AC Bus",
      "🍽️ Breakfast & Morning Tea",
      "🥘 Delicious Veg & Non-Veg Lunch",
      "☕ Evening Tea",
      "🌿 Forest Entry & Permissions",
      "🧭 Experienced Trek Leader & Local Guide",
      "🩺 Basic First Aid & Hydration Support",
    ],
    exclusions: [
      'Any other charges not mentioned in "Inclusions"',
      "Personal snacks, cold drinks, and extra food expenses.",
      "Personal insurance or medical expenses.",
      "Any emergency evacuation charges.",
      "Photography or videography permits (if applicable).",
    ],
    verticalCards: [
      { title: "Devkund", image: dev1 },
      { title: "Devkund", image: dev2 },
      { title: "Devkund", image: dev3 },
      { title: "Devkund", image: dev4 },
      { title: "Devkund", image: dev5 },
    ],
    trekData: [
      {
        name: "Devkund Waterfall",
        image: dev1,
        info: "Discover the stunning Devkund Waterfall, located in Bhira village, Raigad district, one of Maharashtra's most scenic monsoon trekking destinations. The waterfall is formed by water flowing down from the beautiful Plus Valley and Tamhini Ghat, creating a breathtaking plunge into a crystal-clear natural pool. The trek is approximately , 6 km one way and follows an easy, mostly straight trail through lush forests, river crossings, and picturesque Sahyadri landscapes, making it suitable for beginners and nature lovers. This refreshing trek offers spectacular views, peaceful surroundings, and excellent photography opportunities. Whether you're looking for a relaxing weekend adventure or a memorable escape into nature, the Devkund Waterfall Trek is one of the best experiences near Pune and Mumbai during the monsoon season.",
      },
    ],
    faq: [
      {
        question: "What is Devkund Waterfall famous for?",
        answer:
          "Devkund is known for its stunning plunge waterfall, crystal-clear blue waters, scenic forest trail, and breathtaking monsoon beauty in the Sahyadri ranges.",
      },
      {
        question: "Is Devkund Trek suitable for beginners?",
        answer:
          "Yes. The trek is beginner-friendly to moderate and suitable for first-time trekkers with basic fitness levels.",
      },
      {
        question: "How difficult is the Devkund Trek?",
        answer:
          "The trek is considered easy to moderate and includes forest trails, rocky sections, and stream crossings during monsoon.",
      },
      {
        question: "What should I carry for the trek?",
        answer:
          "Carry a small backpack, water bottle, rainwear, trekking shoes with good grip, personal medicines, and energy snacks. For a complete list, please check our Things to Carry section.",
      },
      {
        question: "Are meals included?",
        answer:
          "Yes. Breakfast, morning tea, lunch, and evening tea are included in the package.",
      },
      {
        question: "Is transportation included?",
        answer:
          "Yes, Pune to Pune travel by Non-AC bus is included in the package.",
      },
      {
        question: "Can we swim at Devkund Waterfall?",
        answer:
          "Swimming near the waterfall is prohibited during monsoon due to strong currents and safety concerns.",
      },
      {
        question: "Do we need forest permission?",
        answer:
          "Yes. Devkund falls under a protected forest zone and all required permissions are included in the package.",
      },
      {
        question: "Will there be a trek leader and guide?",
        answer:
          "Yes, experienced trek leaders and local guides will accompany the group throughout the trek.",
      },
    ],
  },
];

const Devkund = () => {
  return (
    <div className="bg-gray-50 ">
      {" "}
      <Header trekData={data[0].trekData[0]} />{" "}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {" "}
        <TrekBasicInfo
          trekName="Devkund Waterfall Trek"
          location="Bhira, Tamhini Region"
          trekDifficulty="Moderate"
          ageLimit="16 to 36 Years"
        />{" "}
        <PackageInclusions />{" "}
      </div>
      ```
      <ItineraryTimeline itinerary={data} />
      <ImageCardsWithVerticalView verticalCards={data[0].verticalCards} />
      <ModalTriggerList
        inclusions={data[0].inclusions}
        exclusions={data[0].exclusions}
        type="trek"
        faq={data[0].faq}
      />
      <JoinEventAction />
    </div>
  );
};

export default Devkund;
